import type { DocumentError } from 'apiConnector/document/document';
import { createContext } from 'react';

export interface TermsheetApi {
  locales: ReadonlyArray<string>;
  quoteQuery: unknown;
  onSuccess(locale: string): void;
  onError(locale: string, error: DocumentError): void;
}

export const TermsheetContext = createContext<TermsheetApi | undefined>(undefined);
